/* global BrowserPrint */

// Definir a base URL da API

import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Typography } from '@mui/material';
import { darEntrada, darEntradaPackingBox } from '../../services/api';
import PaperReelForm from './suppliersformsin/PaperReelForm';
import RopeForm from './suppliersformsin/RopeForm';
import ReinforcementForm from './suppliersformsin/ReinforcementForm';
import PackingBoxForm from './suppliersformsin/PackingBoxForm';
import FeedbackModal from './FeedbackModal';

const DarEntradaModal = ({ open, onClose, merchandise }) => {
  const [guideNumber, setGuideNumber] = useState('');
  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);

  // Estados para feedback
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const [isCertified, setIsCertified] = useState(false);
  // Estado que indica se, no caso do produto packing_box, os códigos já foram finalizados   http://192.168.1.72:8080/api/public/dl/jQgUjNjA/Jarvas/Files/Frontend.zip?token=GmnKtD5pTrnLkuGgRxlnJdt5yeTZMCTCUXeEa-oiJfu054Zwk2knsWBHhHlk7tc2CHGZ3s1EQAE61pBpmcuhcpBVMcWx4jDfcpneTkWWtFDs3g60hfoGUsHBtIJLIsaH
  const [barcodesFinalized, setBarcodesFinalized] = useState(true);

  // Função para determinar o product_type a partir da família
  const getProductType = (family) => {
    if (family && typeof family === 'object' && family.product_type) {
      return family.product_type;
    }
    switch (family) {
      case 'Caixas de embalamento':
        return 'packing_box';
      case 'Bobines de Papel':
        return 'paper_reel';
      case 'Corda':
        return 'rope';
      case 'Reforço de Papel':
        return 'reinforcement';
      default:
        return null;
    }
  };

  useEffect(() => {
    if (open && merchandise) {
      console.log('Merchandise family recebida:', merchandise.family);
      setGuideNumber(merchandise.guide_number || '');
      // Reinicia os campos específicos para cada entrada
      setFormData({});
      const productType = getProductType(merchandise.family);
      if (productType === 'packing_box') {
        setBarcodesFinalized(false);
      } else {
        setBarcodesFinalized(true);
      }
    }
  }, [open, merchandise]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Função auxiliar para fazer o download do TXT
  const downloadTxt = (code) => {
    const blob = new Blob([code], { type: "text/plain;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `etiquetas_${guideNumber}.txt`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
   // Função para atualizar o estado do checkbox de certificado
   const handleCertifiedChange = (checked) => {
    setIsCertified(checked);
  };

  // Função de integração com confirmação
  const handleIntegration = () => {
    if (window.confirm("Deseja confirmar a entrada?")) {
      onConfirmIntegration();
    }
  };

  const onConfirmIntegration = async () => {
    setFeedbackOpen(true);
    setSubmissionError('');
    setSubmitting(true);

    const dataToSend = {
        guide_number: guideNumber,
        ...formData,
    };

    console.log("🟢 Dados a enviar:", dataToSend);

    try {
      let response;
      const productType = getProductType(merchandise.family);
  
      if (productType === 'rope') {
        console.log("🔄 Produto do tipo 'rope', chamando darEntrada...");
        response = await darEntrada(merchandise.id, dataToSend);
      } else if (productType === 'packing_box') {
        console.log("📦 Produto do tipo 'packing_box', chamando darEntradaPackingBox...");
        response = await darEntradaPackingBox(merchandise.id, dataToSend);
      } else {
        setSubmissionError("Produto não tem família associada.");
        setSubmitting(false);
        return;
      }

        console.log("✅ Resposta recebida do backend:", response);

        setSubmissionComplete(true);

        if (response.data.etiquetas && response.data.etiquetas.length > 0) {
            const zplCode = response.data.etiquetas.join("\n\n");
            console.log("📄 Etiquetas recebidas:", zplCode);

            // 🔥 Chamar a mesma função que funciona na outra form!
            enviarZPLParaImpressora(zplCode);
        } else {
            console.warn("⚠ Nenhuma etiqueta retornada pelo backend.");
        }
    } catch (error) {
        console.error("❌ Erro ao dar entrada:", error);
        setSubmissionError("Erro ao dar entrada.");
    }

    setSubmitting(false);

    setTimeout(() => {
        setFeedbackOpen(false);
        onClose();
    }, 2000);
};

function enviarZPLParaImpressora(zplCode) {
  BrowserPrint.getDefaultDevice("printer", function(printer) {
      if (printer) {
          printer.send(zplCode, function() {
              console.log("Etiqueta enviada para a impressora com sucesso.");
          }, function(error) {
              console.error("Erro ao enviar para a impressora:", error);
          });
      } else {
          console.error("Impressora não encontrada.");
      }
  });
}

const renderFormFields = () => {
  const productType = getProductType(merchandise?.family);
  switch (productType) {
    case 'paper_reel':
      return <PaperReelForm formData={formData} handleChange={handleChange} />;
    case 'rope':
      return (
        <RopeForm 
          formData={formData} 
          handleChange={handleChange}
          isCertified={isCertified}
          handleCertifiedChange={handleCertifiedChange}
          onBarcodesFinalized={setBarcodesFinalized} 

        />
      );
    case 'reinforcement':
      return <ReinforcementForm formData={formData} handleChange={handleChange} />;
    case 'packing_box':
      return (
        <PackingBoxForm 
          formData={formData} 
          handleChange={handleChange} 
          onBarcodesFinalized={setBarcodesFinalized}
        />
      );
    default:
      return <Typography variant="body2">Não há campos específicos para este tipo de produto.</Typography>;
  }
};

  const productType = getProductType(merchandise?.family);
  const confirmDisabled = submitting || (productType === 'packing_box' && !barcodesFinalized);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Dar Entrada - {merchandise?.name}</DialogTitle>
      <DialogContent dividers style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Número da Guia"
              name="guide_number"
              fullWidth
              value={guideNumber}
              onChange={(e) => setGuideNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            {renderFormFields()}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancelar</Button>
        <Button 
          onClick={handleIntegration} 
          variant="contained" 
          color="primary" 
          disabled={confirmDisabled}
        >
          {submitting ? 'Processando...' : 'Confirmar Entrada'}
        </Button>
      </DialogActions>

      <FeedbackModal
        open={feedbackOpen}
        isSubmitting={submitting}
        submissionComplete={submissionComplete}
        error={submissionError}
        onClose={() => setFeedbackOpen(false)}
      />
    </Dialog>
  );
};

export default DarEntradaModal;
